import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import {
  actionAddArray2Redux,
  selectARecord,
  initSelectedRecord,
  setUiFlag,
  loadAllStats,
  resetRedux,
  loadFbData,
  notifyUsers,
  getId,
  getAcctStatement,
  getAcctBalance
} from "../../../../store/actions";
import ContentGridVanilla from "../ContentGrid/ContentGridVanilla";
import {
  MainRegion,
  Content,
  Container,
  Card,
  Button,
  CardAreaMain,
  CardContent,
  CardActions,
  CardActionsMain,
  CardActionsSupplemental
} from "reactackle";
import getDefs from "../../../../staticData/getDefs";
import { searchRecords } from "../../searches/searchRecords";
import getEditView from "./getEditView";
import {
  getMenuList,
  getCaption,
  getInitData,
  getSideBar
} from "./getMenuList";
import "./landingPage.css";
import { throttle, debounce } from "throttle-debounce";
import GridFilters from "../ContentGrid/GridFilters";
import GridDateFilters from "../ContentGrid/GridDateFilters";
import { isMobile } from "react-device-detect";
import numeral from "numeral";
import getExtendedOgDefs from "../../TableDefinitions/extendedOgDef";
import getInputField from "../customFields/getInputField";
import moment from "moment";
import InventoryGrid from "../ContentGrid/InventoryGrid";

class LandingPage extends Component {
  constructor(props) {
    super(props);
    ////console.log("...test... " + JSON.stringify(tableDefs));
    this.state = {
      data: {
        path: "",
        payload: {
          paymentType: "",
          supplierInvoice: "",
          referenceNumber: "",
          paymentDate: ""
        }
      },
      message: "",
      hasLoaded: false,
      tableName: "bcsHome",
      tableDefs: getDefs(this.props.createTable),
      searchVal: "",
      showGrid: false,
      showDash: true,
      searchFilters: {},
      searchDateFilters: {},
      showFilters: true,
      showPivot: false,
      reRenderFlag: false,
      formDefs: getExtendedOgDefs(this.props.createTable)
    };
    this.getDataDebounced = debounce(1000, this.doStateUpdateForSearch);
    this.getDataThrottled = throttle(1000, this.doStateUpdateForSearch);
  }

  componentDidCatch(error, info) {
    //handle the sending message to backend? store back to db? send notification?
    console.log("Uncaught : " + error + " | " + info);
    this.switchMenu("signout");
  }

  componentDidMount() {
    this.setState(prevState => {
      return {
        ...prevState,
        showFilters: !isMobile
      };
    });

    //console.log("adding scroll listner");
    let scrollElement = window.document.querySelector(".content");
    if (scrollElement && scrollElement !== undefined) {
      scrollElement.addEventListener("scroll", this.handleScroll, false);
    }

    if (!this.props.userUid || this.props.userUid === undefined) {
      console.log("pushing back");
      browserHistory.push("/login");
    } else {
      //console.log("~ this is admin? " + this.props.isAdmin);
      let allTableDets = this.props.userMenus;
      if (allTableDets && allTableDets.length > 0) {
        for (let k = 0; k < allTableDets.length; k++) {
          this.loadDataEx(allTableDets[k]);
        }
      }

      // this.loadData("projects");
      // this.loadData("reports");
      // this.loadData("contacts");
      // this.loadData("logistics");
      // this.loadData("notices");
      // this.loadData("projectDos");
      // this.loadData("projectPos");
      // this.loadData("projectQuotes");
      // this.loadData("suppliers");
      // this.loadData("tasks");
      // this.loadData("attendance");
      // this.props.isAdmin && this.loadData("projectInvoices");
      this.props.isAdmin && this.loadData("projectInvoices", true);
      // this.props.isAdmin && this.loadData("projectClaims");
      // this.props.isAdmin && this.loadData("reports");

      this.props.isAdmin && this.loadData("createFields");
      this.props.isAdmin && this.loadData("listOfTables");
    }
  }

  componentWillUnmount() {
    console.log("detaching scroll listner");
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    // console.log(
    //   "scrolling... " + window.document.querySelector(".content").scrollTop
    // );

    let last_known_scroll_position = 0;
    let ticking = false;

    if (this.state.showGrid) {
      //console.log("setting scroll pos");
      last_known_scroll_position = window.document.querySelector(".content")
        .scrollTop;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.props.onSetUiFlag(
            "listYPos",
            window.document.querySelector(".content").scrollTop
          );
          ticking = false;
        });

        ticking = true;
      }
    }
  };

  setScroll = setToTop => {
    //console.log("attempting scroll");
    let element = window.document.querySelector(".content");
    if (element && element !== "") {
      //console.log("setting scroll");
      if (setToTop) {
        //console.log("setting to 0");
        element.scroll(0, 0);
      } else {
        //console.log("setting to " + this.props.listYPos);
        element.scroll(0, parseInt(this.props.listYPos));
      }
    } else {
      //console.log("element not found");
    }
  };

  applyDataCondition = (singleRecord, dataCondition) => {
    //console.log("~~||~~ " + JSON.stringify(singleRecord));
    //console.log("~~ in the loop" + JSON.stringify(dataCondition));
    let tmpRes = false;

    for (let p = 0; p < dataCondition.length; p++) {
      // console.log(
      //   "~~~ signRec: " +
      //     singleRecord[dataCondition[p]["colKey"]] +
      //     " cond: " +
      //     dataCondition[p]["colKey"] +
      //     "=" +
      //     dataCondition[p]["fieldVal"] +
      //     " OR " +
      //     this.props.userProfile[dataCondition[p]["fieldVal"]]
      // );
      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        dataCondition[p]["fieldVal"]
      ) {
        tmpRes = true;
      }

      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        this.props.userProfile[dataCondition[p]["fieldVal"]]
      ) {
        tmpRes = true;
      }
    }
    //console.log("~~ returning: " + tmpRes);
    return tmpRes;
  };

  loadDataEx = allTableDets => {
    //if (allTableDets.tableName === "visitors") {
    let recsLimit = 0;

    if (!allTableDets || allTableDets === undefined) {
      return [];
    }

    if (isMobile) {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recMobileLimit);
      }
    } else {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recLimit);
      }
    }

    let basePath = "/";
    let tableName = allTableDets.tableName;
    if (recsLimit > 0) {
      this.props.firebase.db
        .ref(basePath + tableName)
        .limitToLast(recsLimit)
        .on("value", snapshot => {
          let tmpArray = [];
          let fbOject = [];
          Promise.all([snapshot.val()]).then(res => {
            fbOject = res[0];
            if (fbOject && fbOject !== null && fbOject !== undefined) {
              Object.keys(fbOject).map(key => {
                let item = {
                  ...fbOject[key],
                  key: key
                };
                //console.log("~~ Linking " + JSON.stringify(allTableDets));
                if (
                  allTableDets.dataConditions &&
                  allTableDets.dataConditions !== undefined &&
                  allTableDets.dataConditions.length > 0
                ) {
                  //console.log(JSON.stringify(allTableDets.dataConditions));
                  if (
                    this.applyDataCondition(item, allTableDets.dataConditions)
                  ) {
                    tmpArray.push(item);
                  }
                } else {
                  tmpArray.push(item);
                }
              });
            }
            //reverse to have latest at the top
            tmpArray.reverse();
            this.props.onAddRecord({
              path: tableName,
              payload: tmpArray
            });
          });
        });
    } else {
      this.props.firebase.db.ref(basePath + tableName).on("value", snapshot => {
        let tmpArray = [];
        let fbOject = [];
        Promise.all([snapshot.val()]).then(res => {
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            Object.keys(fbOject).map(key => {
              let item = {
                ...fbOject[key],
                key: key
              };
              //console.log("~~ Linking " + JSON.stringify(allTableDets));
              if (
                allTableDets.dataConditions &&
                allTableDets.dataConditions !== undefined &&
                allTableDets.dataConditions.length > 0
              ) {
                //console.log(JSON.stringify(allTableDets.dataConditions));
                if (
                  this.applyDataCondition(item, allTableDets.dataConditions)
                ) {
                  tmpArray.push(item);
                }
              } else {
                tmpArray.push(item);
              }
            });
          }
          //reverse to have latest at the top
          tmpArray.reverse();
          this.props.onAddRecord({
            path: tableName,
            payload: tmpArray
          });
        });
      });
    }
    //}
  };

  loadData = (tableName, isDeleted) => {
    //console.log(tableName);
    let recsLimit = 3000;
    if (isMobile) {
      recsLimit = 2000;
    }
    if (tableName === "attendance") {
      if (isMobile) {
        recsLimit === 2000;
      } else {
        recsLimit === 3000;
      }
    }
    let basePath = "/";
    if (isDeleted) {
      basePath = "/deletedRecs/";
    }
    this.props.firebase.db
      .ref(basePath + tableName)
      .limitToLast(recsLimit)
      .on("value", snapshot => {
        ////console.log("Linking " + tableName);
        let tmpArray = [];
        let fbOject = [];
        let projTempArray = [];
        Promise.all([snapshot.val()]).then(res => {
          //basic updating keys into objects
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            tmpArray = Object.keys(fbOject).map(key => ({
              ...fbOject[key],
              key: key
            }));
          }
          //reverse to have latest at the top
          tmpArray.reverse();

          //filter project table for engineer and contributor
          if (
            tableName === "projects" &&
            (this.props.currUserRole === "ENGINEER" ||
              this.props.currUserRole === "CONTRIBUTOR")
          ) {
            projTempArray = tmpArray.filter(item => {
              return item.projectPhase === "IN FLIGHT";
            });

            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: projTempArray
              });
            } else {
              this.props.onAddRecord({
                path: tableName,
                payload: projTempArray
              });
            }
          } else {
            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: tmpArray
              });
            } else {
              this.props.onAddRecord({ path: tableName, payload: tmpArray });
            }
          }
        });
      });
  };

  getTopMenu = () => {
    return (
      <nav className="navbar navbar-default navbar-fixed-top">
        <div
          className="container-fluid"
          style={{
            paddingTop: "25px"
          }}
        >
          <div className="navbar-header">
            <button
              type="button"
              className="pull-left navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navMenu"
              aria-expanded="false"
              style={{
                marginLeft: "10px"
              }}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a
              className="navbar-brand"
              href="#"
              style={{
                marginLeft: "-20px",
                marginRight: "-20px",
                color: "black"
              }}
            >
              {getCaption(
                this.state.tableName,
                this.props.listOfTables,
                isMobile
              )}
            </a>

            {this.state.showGrid && !this.state.showDash && (
              <button
                type="button"
                className="pull-right navbar-toggle"
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  marginTop: "10px",
                  paddingRight: "13px",
                  paddingLeft: "13px",
                  paddingTop: "5px",
                  paddingBottom: "5px"
                }}
              >
                <span
                  class="fa fa-filter fa-lg"
                  aria-hidden="true"
                  onClick={() => {
                    this.setState(prevState => {
                      return {
                        ...prevState,
                        showFilters: !prevState.showFilters
                      };
                    });
                  }}
                ></span>
              </button>
            )}

            {this.state.showGrid && (
              <button
                type="button"
                className="pull-right navbar-toggle"
                style={{
                  marginLeft: "10px",
                  marginRight: "0px",
                  marginTop: "10px",
                  paddingRight: "13px",
                  paddingLeft: "13px",
                  paddingTop: "5px",
                  paddingBottom: "5px"
                }}
              >
                <span
                  class="fa fa-plus fa-lg"
                  aria-hidden="true"
                  onClick={() => this.handleAddNew()}
                ></span>
              </button>
            )}
          </div>
          {!this.state.showDash && this.state.showFilters && (
            <div
              style={{
                marginTop: "15px",
                marginBottom: "15px"
              }}
            >
              {this.state.showGrid &&
                this.state.showFilters &&
                this.getSearchBar()}

              {this.state.showGrid &&
                this.state.showFilters &&
                this.getFilterDropDowns()}
            </div>
          )}
          <div>{this.getTotals()}</div>

          <div className="collapse navbar-collapse" id="navMenu">
            <ul className="nav navbar-nav navbar-left">{this.fetchMenus()}</ul>
          </div>
        </div>
      </nav>
    );
  };

  fetchMenus = () => {
    //console.log("Fetching...");
    //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
    return getMenuList(
      true,
      this.isAdmin(),
      this.switchMenu,
      this.props.currUserRole,
      this.props.userMenus
    );
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  logoutApp = () => {
    let msgToApp = {
      actionType: "logOut",
      payload: {}
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing logout message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  switchMenu = menuName => {
    let unhandledMenu = [
      "checkLists",
      "clientFeedback",
      "soa",
      "chequesPayments",
      "creditNotes"
    ];
    if (unhandledMenu.includes(menuName)) {
      alert("Wheels are spinning.... \nThis feature is coming soon!!!");
      return;
    }
    if (this.refs && this.refs.searchText) {
      this.refs.searchText.value = "";
      this.doDelaySearch();
    }
    this.stateChangeHandler({}, "searchFilters", false);
    this.stateChangeHandler({}, "searchDateFilters", false);
    this.stateChangeHandler(false, "showPivot", false);
    if (menuName === "dashboard" || menuName === "bcsHome") {
      this.stateChangeHandler(true, "showDash", false);
      this.stateChangeHandler(false, "showGrid", false);
      this.stateChangeHandler(menuName, "tableName", false);
    } else if (menuName === "signout") {
      this.props.firebase.doSignOut();
      this.props.onSignOut();
      this.logoutApp();
      browserHistory.push("/login");
    } else {
      this.stateChangeHandler(true, "showGrid", false);
      this.stateChangeHandler(false, "showDash", false);
      this.stateChangeHandler(menuName, "tableName", false);
      this.setScroll(true);
    }
  };

  isAdmin = () => {
    return this.props.isAdmin || this.props.isSuperAdmin;
  };

  handleDelete = (key, path, searchObj) => {
    this.props.firebase.db.ref("/" + path + "/" + key).remove();
    this.genNotification(searchObj, "delete");
    this.stateChangeHandler(true, "showGrid", false);
  };

  handleEdit = (key, path, fullPayload) => {
    //alert("Here is the key: " + key + " here is the path: " + path);
    this.setScroll(true);
    if (path === "deletedprojectInvoices") {
      if (window.confirm("Do you wish to restore this item?")) {
        let cloudPath = "projectInvoices/" + key + "/";
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            snap.ref.set(fullPayload);
          })
          .catch(err => {
            console.log(err);
            return "some error: " + err;
          })
          .then(err => this.handleDelete(key, "deletedRecs/projectInvoices"));
      }
    } else {
      this.stateChangeHandler(false, "showGrid", false);
      this.props.onSelectRecord({ path: path, key: key });
      this.props.onSetUiFlag("operationType", "update");
    }
  };

  handleAddNew = () => {
    ////console.log("generating new");
    let initData = getInitData(
      this.state.tableName,
      this.props.createTable,
      this.props.userProfile
    );
    if (initData && initData !== undefined) {
      this.stateChangeHandler(false, "showGrid", false);
      this.props.onSetUiFlag("operationType", "add");
      this.props.onSetUiFlag("tableName", this.state.tableName);
      this.props.onAddNew({
        path: this.state.tableName,
        data: { ...initData }
      });
    }
  };

  handleEditCancel = () => {
    this.stateChangeHandler(true, "showGrid", false);
    this.setScroll(false);
  };

  getDashView = () => {
    return <InventoryGrid />;
  };

  getFields = () => {
    ////console.log("test");
    alert("test");
  };

  getData = () => {
    let dTableName = this.state.tableName;
    if (this.state.tableName === "viewReports") {
      dTableName = "reports";
    }
    if (dTableName !== "dashboard" && dTableName !== "bcsHome") {
      if (
        this.state.searchVal === "" &&
        Object(this.state.searchFilters).keys &&
        Object(this.state.searchFilters).keys.length === 0
      ) {
        ////console.log("get data returning all");
        if (
          this.props.db[dTableName] &&
          this.props.db[dTableName] !== undefined
        ) {
          return this.props.db[dTableName].slice(0, 300);
        } else {
          return this.props.db[dTableName];
        }
      } else {
        return searchRecords(
          this.props.db[dTableName],
          this.state.searchVal,
          this.state.tableDefs[dTableName].searches,
          this.state.searchFilters,
          this.state.searchDateFilters
        );
      }
    }
  };

  doStateUpdateForSearch = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        searchVal: this.refs.searchText.value
      };
    });
  };

  doDelaySearch = () => {
    ////console.log("doning search...");
    const q = this.refs.searchText.value;
    //this.stateChangeHandler("searchVal", q, false);
    if (q.length < 5) {
      this.getDataThrottled();
    } else {
      this.getDataDebounced();
    }
  };

  getSearchBar = () => {
    return (
      <div className="wrapzz">
        <div className="searchzz">
          <input
            type="text"
            className="searchTermzz"
            placeholder="Search..."
            ref="searchText"
            onKeyUp={() => this.doDelaySearch()}
          />
          <button
            type="submit"
            className="searchButtonzz"
            onClick={() => {
              this.setState(prevState => {
                return {
                  ...prevState,
                  searchVal: this.refs.searchText.value
                };
              });
              ////console.log("searchText " + this.refs.searchText.value);
              ////console.log(JSON.stringify(this.state.searchVal));
            }}
          >
            <i className="fa fa-search"></i>
          </button>
        </div>
      </div>
    );
  };

  getNewButton = () => {
    if (this.state.showGrid) {
      return (
        <Button
          colorScheme="primary"
          onPress={() => this.handleAddNew()}
          text="Add New"
        />
      );
    }
  };

  recordPoPaymentHandler = () => {};

  getPoPaymentButton = () => {
    if (this.state.showGrid && this.state.tableName === "projectPos") {
      return (
        <div
          style={{
            justifyContent: "center",
            verticalAlign: "middle",
            padding: "6px",
            paddingTop: "12px",
            borderWidth: "0.5px",
            borderColor: "blue",
            borderRadius: "2px",
            backgroundColor: "#2196F3"
          }}
        >
          <a
            href="javascript:void(0)"
            data-toggle="modal"
            data-target="#myModal"
            style={{
              font: "inherit",
              cursor: "pointer",
              userSelect: "none",
              fontFamily:
                "Open Sans,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif",
              boxSizing: "border-box",
              color: "white",
              textAlign: "inherit",
              fontSize: "inherit",
              lineHeight: "1.25",
              fontWeight: "600",
              textTransform: "uppercase",
              paddingTop: "12px"
            }}
          >
            Add Payment Details
          </a>
        </div>
      );
    }
  };

  getPivotButton = () => {
    if (
      this.state.showGrid &&
      this.state.tableName !== "reports" &&
      !isMobile
    ) {
      return (
        <Button
          colorScheme="primary"
          onPress={() =>
            this.stateChangeHandler(!this.state.showPivot, "showPivot", false)
          }
          text={this.state.showPivot ? "Show Grid" : "Show Pivot"}
        />
      );
    }
  };

  getFiltersList = () => {
    let filtersList = [];
    let tableObj = this.props.createTable.find(
      item => item.name === this.state.tableName
    );

    if (tableObj && tableObj !== undefined) {
      if (tableObj.filters && tableObj.filters !== undefined) {
        filtersList = tableObj.filters;
      }
    }

    return filtersList;
  };

  getFilterDropDowns = () => {
    if (this.state.showGrid) {
      return (
        <div>
          <GridFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
          <GridDateFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchDateFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
        </div>
      );
    }
  };

  getTotals = () => {
    let totTables = ["projectInvoices", "projectPos"];

    if (totTables.includes(this.state.tableName)) {
      let sumField = "";
      if (this.state.tableName === "projectInvoices") {
        sumField = "totalInvoice";
      } else if (this.state.tableName === "projectPos") {
        sumField = "poAmount";
      }
      if (sumField !== "") {
        let filteredRecs = this.getData();
        let sum = filteredRecs.reduce(function(totValue, curr) {
          return totValue + parseFloat(curr[sumField]);
        }, 0);
        let gstSum = sum * 1.07;
        if (isMobile) {
          return (
            <table className="table table-sm" style={{ marginBottom: "0px" }}>
              <tr>
                <td style={{ width: "50%", textAlign: "left" }}>
                  TOTAL:{" "}
                  {" " + numeral(sum.toFixed(2)).format("0,0.00") + "   "}
                </td>
                <td style={{ width: "50%", textAlign: "right" }}>
                  TOTAL(W GST):{" "}
                  {" " + numeral(gstSum.toFixed(2)).format("0,0.00")}
                </td>
              </tr>
            </table>
          );
        } else {
          return (
            <CardActionsMain>
              <div
                className="row"
                style={{
                  marginLeft: "1px",
                  marginRight: "1px",
                  alignItems: "center",
                  padding: "2px",
                  border: "0px",
                  borderBottom: "0px",
                  borderBottomColor: "#cccccc",
                  borderStyle: "solid",
                  paddingBottom: isMobile ? "0px" : "2px"
                }}
              >
                <div
                  className="col-sm-2"
                  style={{
                    textAlign: "right",
                    verticalAlign: "center",
                    border: "0px solid gainsboro",
                    width: "80px"
                  }}
                >
                  <h5>TOTAL</h5>
                </div>
                <div
                  className="col-sm-2"
                  style={{
                    textAlign: "right",
                    verticalAlign: "center",
                    border: "1px solid gainsboro",
                    width: "120px"
                  }}
                >
                  <h5>{numeral(sum.toFixed(2)).format("0,0.00")}</h5>
                </div>
                <div
                  className="col-sm-2"
                  style={{
                    textAlign: "right",
                    verticalAlign: "center",
                    border: "0px solid gainsboro",
                    width: "140px"
                  }}
                >
                  <h5>TOTAL(W GST)</h5>
                </div>
                <div
                  className="col-sm-2"
                  style={{
                    textAlign: "right",
                    verticalAlign: "center",
                    border: "1px solid gainsboro",
                    width: "120px"
                  }}
                >
                  <h5>{numeral(gstSum.toFixed(2)).format("0,0.00")}</h5>
                </div>
              </div>
            </CardActionsMain>
          );
        }
      }
    }
  };

  getTopHeader = () => {
    if (isMobile) {
    } else {
      return (
        <div>
          <Card>
            <CardAreaMain>
              <CardContent>
                <div>
                  <h1>
                    {getCaption(
                      this.state.tableName,
                      this.props.listOfTables,
                      isMobile
                    )}
                  </h1>
                </div>
                {this.getSearchBar()}
                {this.getFilterDropDowns()}
              </CardContent>
              <CardActions>
                <CardActionsSupplemental>
                  {this.getNewButton()}
                  {this.getPivotButton()}

                  {this.getPoPaymentButton()}

                  {/* <LinearProgress
                  indeterminate
                  subtitle="Indeterminate Progress"
                /> */}
                </CardActionsSupplemental>
                {this.getTotals()}
              </CardActions>
            </CardAreaMain>
          </Card>
        </div>
      );
    }
  };

  getNicerData = () => {
    let baseData = this.getData();
    let tableDefHere = this.state.tableDefs[this.state.tableName];
    let nicerData = baseData.map(item => {
      let tmpObj = {};
      for (let key in item) {
        if (
          tableDefHere &&
          tableDefHere[key] &&
          tableDefHere[key].caption &&
          item[key]
        ) {
          tmpObj[tableDefHere[key].caption] = item[key];
        }
      }
      return tmpObj;
    });

    return nicerData;
  };

  getCsvHeaders = () => {
    let headerArray = [];
    let tableDefHere = this.state.tableDefs[this.state.tableName];
    for (let key in tableDefHere) {
      let tmpObj = {};
      if (tableDefHere && tableDefHere[key]) {
        tmpObj["label"] = tableDefHere[key].caption;
        tmpObj["key"] = key;
        headerArray.push(tmpObj);
      }
    }
    return headerArray;
  };

  getGrid = () => {
    if (this.state.showGrid) {
      if (this.state.tableName !== "reports") {
        return (
          <ContentGridVanilla
            data={this.getData()}
            tableName={this.state.tableName}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleEdit}
            handleDelete={this.handleDelete}
          />
        );
      } else {
        return (
          <AdvDashboard
            data={this.getData()}
            reportData={{
              attendance: this.props.db["attendance"],
              projectPos: this.props.db["projectPos"],
              projectInvoices: this.props.db["projectInvoices"]
            }}
            tableName={"reports"}
            tableDef={this.state.tableDefs["reports"]}
            handleEdit={this.handleEdit}
            handleDelete={this.handleDelete}
          />
        );
      }
    }
  };

  getEnrichedString = (ogString, searchObj) => {
    //console.log(ogString + JSON.stringify(searchObj));
    let strArray = ogString.split(" ").map(word => {
      //console.log(word + " = " + searchObj[word]);
      if (searchObj[word] && searchObj[word] !== undefined) {
        return searchObj[word];
      } else {
        return word;
      }
    });

    return strArray.join(" ");
  };

  genNotification = (recPayload, opType) => {
    let usersList = [];
    let updateText = undefined;
    let createText = undefined;
    let deleteText = undefined;
    let tableObj = this.props.createTable.find(
      item => item.name === this.state.tableName
    );

    if (tableObj && tableObj !== undefined) {
      usersList = tableObj.notifyUsers;
      createText = tableObj.createNotifyText;
      updateText = tableObj.updateNotifyText;
      deleteText = tableObj.deleteNotifyText;

      if (
        opType === "update" &&
        updateText &&
        updateText !== "" &&
        updateText !== null
      ) {
        //console.log(" updateText: " + updateText + " opType: " + opType);
        this.props.onNotifyUsers(
          this.getEnrichedString(updateText, recPayload),
          usersList
        );
      } else if (
        opType === "delete" &&
        deleteText &&
        deleteText !== "" &&
        deleteText !== null
      ) {
        //console.log(" deleteText: " + deleteText + " opType: " + opType);
        this.props.onNotifyUsers(
          this.getEnrichedString(deleteText, recPayload),
          usersList
        );
      } else if (
        opType === "create" &&
        createText &&
        createText !== "" &&
        createText !== null
      ) {
        //console.log("createText: " + createText + " opType: " + opType);
        this.props.onNotifyUsers(
          this.getEnrichedString(createText, recPayload),
          usersList
        );
      }
    }
  };

  getSelectedPoCount = () => {
    let poRecs = this.getData();
    if (poRecs && poRecs.length && poRecs.length > 0) {
      return poRecs.length;
    } else {
      return 0;
    }
  };

  getInputField = (fieldName, poDefs) => {
    return getInputField(
      fieldName,
      "projectPos",
      this.state.data,
      this.stateChangeHandler,
      false,
      poDefs,
      this.props.db,
      isMobile
    );
  };

  getPOPaymentFields = () => {
    let poDefs = getExtendedOgDefs(this.props.createTable);
    if (poDefs && poDefs !== undefined && poDefs.projectPos) {
      //console.log("~~~");
      //console.log(JSON.stringify(poDefs.projectPos.paymentType));
      //console.log("~~~: " + JSON.stringify(poDefs.projectPos.paymentType));
      return (
        <div>
          {this.getInputField("paymentType", poDefs)}
          {this.getInputField("supplierInvoice", poDefs)}
          {this.getInputField("referenceNumber", poDefs)}
          {this.getInputField("paymentDate", poDefs)}
        </div>
      );
    }
  };

  getPoPaymentModal = () => {
    return (
      //<!-- Modal -->
      <div className="modal fade" id="myModal" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <h4 className="modal-title">BULK UPDATE FOR PURCHASE ORDERS</h4>
            </div>
            <div className="modal-body">
              <div
                style={{
                  padding: "20px",
                  backgroundColor: "red",
                  color: "white",
                  fontWeight: "600",
                  marginBottom: "15px"
                }}
              >
                Please perform this action with utmost care. Once in progress,
                the upload process cannot be stopped midway.
                <p
                  style={{
                    fontWeight: "bolder"
                  }}
                >
                  {this.getSelectedPoCount()} POs selected for update
                </p>
              </div>

              <p>Please fill in following fields and click update</p>
              <div>
                {this.state.tableName === "projectPos" &&
                  this.getPOPaymentFields()}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                onClick={() => {
                  this.runUpload();
                }}
              >
                Update
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  runUpload = async () => {
    if (
      Object.keys(this.state.searchFilters).length === 0 &&
      Object.keys(this.state.searchDateFilters).length === 0 &&
      this.state.searchVal === ""
    ) {
      alert("Please apply some filter criteria before running payment updates");
    } else {
      let allPosFull = this.getData();
      let allPos = _.cloneDeep(allPosFull);
      for (let i = 0; i < allPos.length; i++) {
        try {
          let currPo = allPos[i];
          currPo["paymentType"] = this.state.data.payload.paymentType;
          currPo["supplierInvoice"] = this.state.data.payload.supplierInvoice;
          currPo["referenceNumber"] = this.state.data.payload.referenceNumber;
          currPo["paymentDate"] = this.state.data.payload.paymentDate;
          if (currPo.paymentDate === "") {
            currPo.paymentDate = moment()
              .format("DD-MM-YYYY")
              .toString();
          }

          await this.dataUpdateHandler(
            currPo,
            "projectPos/" + currPo.key + "/",
            "poId"
          );
          await this.sleep(1000);
        } catch (err) {
          console.log("some error: " + err);
        }
      }
      alert("Upload completed");
    }
  };

  getMainContent = () => {
    return (
      <MainRegion>
        {this.props.currentUser &&
          this.props.users &&
          getSideBar(
            false,
            this.isAdmin(),
            this.switchMenu,
            this.props.currUserRole,
            this.props.userMenus
          )}

        <Content>
          <Container>
            {this.state.showGrid &&
              this.state.showFilters &&
              this.getTopHeader()}

            <div
              style={{
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
                scrollBehavior: "smooth",
                marginTop: "60px"
              }}
            >
              {this.state.showDash &&
                this.props.userProfile &&
                this.props.userProfile.userEmail ===
                  "ahmed_fayyaz@outlook.com" &&
                this.getDataUpdating()}
              {this.getGrid()}
              {this.state.showDash && this.getDashView()}
            </div>
            {!this.state.showGrid && !this.state.showDash && (
              <div
                style={{
                  marginTop: isMobile ? "-20px" : "-58px"
                }}
              >
                {getEditView(
                  this.state.tableName,
                  this.handleEditCancel,
                  this.handleDelete,
                  this.props.create,
                  this.genNotification
                )}
              </div>
            )}
          </Container>
          <div
            style={{
              minHeight: "500px"
            }}
          ></div>
        </Content>
      </MainRegion>
    );
  };

  sleep = async milliseconds => {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  };

  dataUpdateHandler = async (databucket, cloudPath, idField) => {
    if (databucket && databucket.key && databucket.key !== "") {
      this.props.firebase.db
        .ref("/" + cloudPath + "/" + databucket.key + "/")
        .once("value")
        .then(snap => {
          return snap.ref.set(databucket);
        })
        .catch(err => {
          console.log("some error: " + err);
        })
        .then(err => {
          //console.log("Updated Rec: " + databucket[idField]);
        });
    }

    //this.props.handleEditCancel();
  };

  dataAddHandler = async (databucket, cloudPath, idField) => {
    if (databucket && databucket !== undefined) {
      var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
      let dbKey = newInv.key;
      newInv
        .set(databucket)
        .catch(err => {
          console.log("some error: " + err);
        })
        .then(err => {});
    }

    //this.props.handleEditCancel();
  };

  perfDelayUpdates = async () => {
    //========CHECK COMPANY OR SUPPLIER IN DATA=========
    // for (let i = 0; i < myData.length; i++) {
    //   let supplierObj = this.props.suppliers.find(
    //     item =>
    //       item.supplierCompany.toLowerCase() ===
    //       myData[i].supplier.toLowerCase()
    //   );
    //   let paymentTypeObj = this.props.db["paymentTypes"].find(
    //     item =>
    //       item.paymentName.toLowerCase() === myData[i].paymentType.toLowerCase()
    //   );
    //   // if (supplierObj && supplierObj !== undefined) {
    //   //   //console.log("checking supplier: " + myData[i].supplier + " Found");
    //   // } else {
    //   //   console.log(
    //   //     myData[i].supplier + " , " + myData[i].gstAmount + ":  Not Found"
    //   //   );
    //   // }
    //   if (
    //     (!paymentTypeObj && paymentTypeObj === undefined) ||
    //     (!supplierObj && supplierObj === undefined)
    //   ) {
    //     let tmpStr = "";
    //     if (!paymentTypeObj && paymentTypeObj === undefined) {
    //       tmpStr = tmpStr + " paymentType Not Found, ";
    //     }
    //     if (!supplierObj && supplierObj === undefined) {
    //       tmpStr = tmpStr + " supplier Not Found, ";
    //     }
    //     console.log(
    //       myData[i].supplier +
    //         " , " +
    //         myData[i].paymentType +
    //         " , " +
    //         myData[i].paymentDetails +
    //         " , " +
    //         myData[i].gstAmount +
    //         tmpStr
    //     );
    //   }
    // }
    //==========PO & INVOICE DATA UPLOAD=============
    // if (
    //   this.props.projectPos &&
    //   this.props.projectPos.length &&
    //   this.props.projectPos.length > 0
    // ) {
    //   let allPosFull = _.cloneDeep(this.props.projectInvoices);
    //   let allPos = allPosFull.filter(item =>
    //     item.invoiceId.includes("BS/I/18")
    //   );
    //   for (let i = 0; i < allPos.length; i++) {
    //     try {
    //       let currPo = allPos[i];
    //       //console.log(JSON.stringify(currPo));
    //       let poId = currPo.invoiceId;
    //       let poAmount = currPo.totalInvoice;
    //       if (!isNaN(poAmount)) {
    //         poAmount = parseFloat(poAmount);
    //       }
    //       let gstAmount = (poAmount * 0.07).toFixed(2);
    //       let gstTotalAmount = poAmount * 1 + gstAmount * 1;
    //       gstTotalAmount = gstTotalAmount.toFixed(2);
    //       console.log(
    //         i +
    //           "," +
    //           allPos.length +
    //           "," +
    //           poId +
    //           "," +
    //           poAmount +
    //           "," +
    //           gstAmount +
    //           "," +
    //           gstTotalAmount
    //       );
    //       currPo["gstAmount"] = gstAmount;
    //       currPo["gstTotalAmount"] = gstTotalAmount;
    //       await this.dataUpdateHandler(
    //         currPo,
    //         "projectInvoices/" + currPo.key + "/",
    //         "invoiceId"
    //       );
    //       await this.sleep(1000);
    //     } catch (err) {
    //       console.log("some error: " + err + " poId:" + currPo.invoiceId);
    //     }
    //   }
    //   this.props.onSetUiFlag("dataUploadButton", false);
    // }
    //=============EXPENSE DATA CLEANUP==========
    // let myData = Object.keys(myDataFull).map(key => {
    //   return {
    //     ...myDataFull[key],
    //     key: key
    //   };
    // });
    // let tgtArray = myData.map(item => {
    //   if (item.account === "OFFICE SUPPLIES") {
    //     item.account = "OFFICE EXPENSES";
    //   }
    //   if (item.contraAccount === "CASH") {
    //     item.contraAccount = "COMPANY CASH ACCOUNT";
    //   }
    //   if (item.contraAccount === "KABIR CASH") {
    //     item.contraAccount = "KABIR CASH ACCOUNT";
    //   }
    //   return item;
    // });
    //alert(tgtArray.length);
    //EXPENSE DATA UPLOAD
    //console.log(JSON.stringify(tgtArray));
    // for (let i = 0; i < tgtArray.length; i++) {
    //   let currBucket = tgtArray[i];
    //   this.dataAddHandler(currBucket, "expense/");
    //   await this.sleep(1000);
    // }
    //=============ACCOUNTING RULES DATA UPDATE==========
    // let myData = Object.keys(accData).map(key => accData[key]);
    // console.log(myData.length);
    // for (let i = 0; i < myData.length; i++) {
    //   let currBucket = myData[i];
    //   this.dataAddHandler(currBucket, "accounts/");
    //   await this.sleep(1000);
    // }
  };

  getDataUpdating = () => {
    // return (
    //   <div
    //     style={{
    //       backgroundColor: "black",
    //       height: "400px"
    //     }}
    //   >
    //     <div
    //       style={{
    //         color: "white"
    //       }}
    //     >
    //       Please do not click on this button
    //       <div>
    //         <Button
    //           colorScheme="primary"
    //           onPress={() => {
    //             //this.props.onSetUiFlag("dataUploadButton", true);
    //             //this.perfDelayUpdates();
    //             console.log(JSON.stringify(this.props.deliveryRequest));
    //           }}
    //           text="Update Action"
    //         />
    //       </div>
    //     </div>
    //   </div>
    // );
  };

  getClients = () => {
    let allOrders = this.props.deliveryRequest;
    if (allOrders && allOrders.length > 0) {
      return allOrders.map(singOrder => {
        return (
          <tr>
            <td>{singOrder.name}</td>
            <td>{singOrder.author}</td>
            <td>{singOrder.mobile}</td>
            <td>{singOrder.address}</td>
          </tr>
        );
      });
    }
  };

  render() {
    return (
      <div>
        {this.state.tableName === "projectPos" && this.getPoPaymentModal()}
        {/* <div>{isMobile && this.getTopMenu()}</div>
        {isMobile && (
          <div className="content">
            <div>{this.getMainContent()}</div>
          </div>
        )}
        {!isMobile && this.getMainContent()} */}
        {isMobile && this.getTopMenu()}
        {/* {isMobile===false &&  (
          <div className="content">
            <div>{this.getMainContent()}</div>
          </div>
        )} */}

        <div
          className="content"
          style={{
            marginTop: isMobile ? "50px" : "0px"
          }}
        >
          <div
            style={{
              minHeight: "50000px"
            }}
          >
            {this.getMainContent()}
            <table>
              <thead>
                <td>NAME</td>
                <td>AUTHOR</td>
                <td>MOBILE</td>
                <td>ADDRESS</td>
              </thead>
              <tbody>{this.getClients()}</tbody>
            </table>
          </div>
        </div>

        {/* {!isMobile && this.getMainContent()} */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    userMenus: state.ui.userMenus,
    users: state.db.users,
    projects: state.db.projects,
    attendance: state.db.attendance,
    contacts: state.db.contacts,
    logistics: state.db.logistics,
    notices: state.db.notices,
    projectInvoices: state.db.projectInvoices,
    deletedprojectInvoices: state.db.deletedprojectInvoices,
    projectClaims: state.db.projectClaims,
    projectDos: state.db.projectDos,
    projectPos: state.db.projectPos,
    projectQuotes: state.db.projectQuotes,
    reports: state.db.reports,
    suppliers: state.db.suppliers,
    tasks: state.db.tasks,
    currentUser: state.db.userProfile,
    isAdmin: state.ui.isThisAdmin,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    userUid: state.ui.userUid,
    currUserRole: state.ui.currUserRole,
    createFields: state.db.createFields,
    createTable: state.db.createTable,
    testTable: state.db.testTable,
    listOfTables: state.db.listOfTables,
    menuDesigner: state.db.menuDesigner,
    uploadButton:
      state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined
        ? state.ui.dataUploadButton
        : false,
    db: state.db,
    listYPos: state.ui.listYPos
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => {
      dispatch(selectARecord(params));
      dispatch(setUiFlag("tableName", params.path));
    },
    onAddNew: data => dispatch(initSelectedRecord(data)),
    loadStats: parsedRes => dispatch(loadAllStats(parsedRes)),
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onSignOut: () => {
      dispatch(resetRedux());
      dispatch(setUiFlag("userMenus", []));
    },
    loadFbData: (tableName, firebase) =>
      dispatch(loadFbData(tableName, firebase)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers)),
    onGetId: data => dispatch(getId(data)),
    onGetAcctStatement: data => dispatch(getAcctStatement(data)),
    onGetAcctBalance: data => dispatch(getAcctBalance(data))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(LandingPage);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/LandingPage.jsx